import { SVGProps } from 'react';

const SvgOcd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <g clipPath="url(#OCD_svg__a)">
      <path
        fill="#FC3"
        d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
      />
      <path
        fill="#FFD45C"
        d="M6.832 19.956c.024-4.22.048-8.584-.06-12.964-.036-1.476-.108-2.756-.252-3.88a16.303 16.303 0 0 0-2.072 1.82c.04.636.072 1.332.092 2.112.108 4.344.084 8.692.06 12.896a872.085 872.085 0 0 0-.016 7.264 15.88 15.88 0 0 0 1.964 1.7c.168-.196.272-.452.272-.732-.02-2.764 0-5.54.012-8.224v.008Z"
      />
      <path
        fill="#FFDE83"
        d="M15.536 20.688a1.117 1.117 0 0 0-2.232.04c.024 1.4.036 2.736.048 4.024.02 2.36.044 4.636.14 7.048.732.116 1.48.176 2.24.188-.104-2.488-.128-4.828-.152-7.26-.012-1.296-.024-2.636-.048-4.044l.004.004Z"
      />
      <path
        fill="#FFE9AB"
        d="M19.964 28.016c.04-4.864.008-8.308-.028-11.952-.04-4.016-.08-8.164-.016-14.484 0-.364-.008-.732-.028-1.1a15.715 15.715 0 0 0-2.268-.396c.048.496.072.988.068 1.476a651.243 651.243 0 0 0 .016 14.532c.036 3.636.068 7.068.028 11.912-.012 1.472.024 2.756.152 3.888a15.71 15.71 0 0 0 2.184-.412c-.096-.956-.12-2.1-.108-3.456v-.008Z"
      />
      <path
        fill="#FB3"
        d="M11.204 14.92c.012-2.36.028-4.804.036-7.204.008-2.244.012-4.556-.472-6.84-.724.252-1.428.552-2.1.9.348 1.932.348 3.956.34 5.932-.008 2.396-.024 4.836-.036 7.196-.028 5.036-.06 10.204-.04 15.448.716.352 1.464.656 2.236.9-.028-5.544 0-11.016.032-16.336l.004.004Z"
      />
      <path
        fill="#FFDE83"
        d="m13.524 7.904-.032 3.56c-.016 1.792-.032 3.584-.044 5.372a1.116 1.116 0 0 0 1.108 1.124h.008c.612 0 1.112-.492 1.116-1.108.016-1.792.032-3.584.044-5.372l.032-3.56c.024-2.596.04-5.268-.416-7.908-.756.032-1.496.116-2.22.248.444 2.492.424 5.104.404 7.64v.004Z"
      />
    </g>
    <defs>
      <clipPath id="OCD_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgOcd;
